const PACKAGES_COMPARE = {
  PAGE_TITLE: 'قیمت | رایچت',

  HEADING_TITLE: 'برای شرکت‌های بزرگ و کوچک',
  HEADING_DESCRIPTION:
    'ما در رایچت بستری را فراهم کرده ایم تا مشتریان ما بتوانند به صورت آزمایشی، یک دوره 14 روزه داشته باشند و از امکانات ما به صورت رایگان استفاده کنند. بعد از اتمام این 14 روز می توانید مطابق نیازتان، هرکدام از پکیج های ما را که می خواهید سفارش دهید.',

  PROFESSIONAL: 'پایه',
  PROFESSIONAL_FEATURES_TITLE: '',

  PROFESSIONAL_FEATURES: [
    'به ازای هر ماه ۵۰۰ شارژ مکالمه اولیه',
    'آرشیو ۳۰ روز مکالمات',
    'مدیریت ۱ وب سایت',
    'مکالمه ما بین اپراتورها',
    'انتقال گفتگو مابین اپراتورها',
    'تعداد اپراتور نامحدود',
    'امکان آپلود فایل تا ۱۰ مگابایت',
    'پیام ها جهت پشتیبانی  تا ۷۲ ساعت پاسخ داده می شوند .',
    'پشتیبانی فنی شامل هزینه جداگانه می باشد .',
    'این پکیج شامل پشتیبانی تلفنی نمی شود .',
  ],

  PROFESSIONAL_PRICE: '۸۹',
  PROFESSIONAL_PRICE_PERIOD: 'ماهانه',
  PROFESSIONAL_SUB_PRICE: 'در صورت خرید اکانت سالانه',

  COMMERICAL: 'تجاری',
  COMMERICAL_FEATURES_TITLE: '+ تمامی امکانات پکیج پایه ',

  COMMERICAL_FEATURES: [
    '۱۰۰۰ مکالمه‌ی جدید',
    'آمار حرفه‌ای اپراتور‌ها',
    'خروجی اکسل از اطلاعات کاربران',
    'ارسال ۶ پیام‌ هوشمند',
    'اختصاص اپراتور به لینک',
    'امکان آپلود فایل تا ۲۰ مگابایت',
    'امکان استفاده از API',
    'پاسخ‌های آماده',
    'اتصال به تلگرام',
    'ارسال ویس در ابزارک',
    'افزودن کاربر به لیست اسپم',
    'امکان حذف متن "قدرت گرفته از رایچت " در ابزارک',
    'شخصی سازی فرم‌ها',
  ],
  COMMERICAL_PRICE: ' ۲۷۹',
  COMMERICAL_PRICE_PERIOD: 'ماهانه',
  COMMERICAL_SUB_PRICE: 'در صورت خرید اکانت سالانه',

  PREMIUM: 'پریمیوم',
  PREMIUM_PLUS: 'پریمیوم پلاس',
  PREMIUM_FEATURES_TITLE: '+ تمامی امکانات پکیج تجاری',
  PREMIUM_FEATURES: [
    'مکالمه جدید نامحدود ',
    'وب سایت جدید نامحدود',
    'تعداد بازدید همزمان نامحدود',
    'ارسال پیام‌های هوشمند نامحدود',
    'ربات پاسخگویی',
    'حالت انتظار',
    'نقشه‌ی راه',
    'مانیتوریتگ لحظه‌ای بازدید کنندگان',
    'امکان آپلود فایل تا ۳۰ مگابایت',
    'خروجی اکسل + آمار حرفه‌ای اپراتورها',
    'شخصی سازی لوگوی سازما‌‌نی در ابزارک',
    'اتصال مستقیم با واتس‌اپ (پاسخگویی واتس‌اپ از رایچت)',
    'ارسال ایمیل به کاربران',
    'اکسپورت متن چت ها',
    'آمار رضایت مشتری',
    'پیام گروهی',
    'تیم و دپارتمان بندی',
    'وب هوک برای کاربران و چت‌ها',
    'پشتیبانی اختصاصی',
  ],
  PREMIUM_PRICE: '۸۷۹',
  PREMIUM_PRICE_PERIOD: 'ماهانه',
  PREMIUM_SUB_PRICE: 'در صورت خرید اکانت سالانه',
  START: 'شروع کنید',
  TRY_14_DAYS_FREE: '۱۴ روز به صورت رایگان امتحان کنید ',
  COMPARE_PACKAGES: 'مقایسه پکیج‌های رایچت',
  MODAL_FEATURES_TITLE: 'ویژگی ها',
  MODAL_FEATURES: [
    'ویژگی ها',
    'ماهانه',
    'سالانه (۱۰٪ تخفیف)',
    'شارژ مکالمه اولیه / ماهانه',
    'هزینه شارژ مکالمه',
    'تعداد وب سایت',
    'تعداد اپراتور',
    'ربات پاسخگویی',
    'پاسخگویی واتس‌اپ از رایچت',
    'ارسال پیام‌های هوشمند',
    'تعداد ویو همزمان',
    'محدودیت ارسال هر فایل',
    'آرشیو مکالمات',
    'چت بات هوش مصنوعی',
    'حالت انتظار',
    'نقشه‌ی راه',
    'شخصی سازی فرم‌ها',
    'وب هوک',
    'اختصاص اپراتور به لینک',
    'ارسال ویس از ابزارک',
    'دپارتمان',
    'اپلیکیشن اندروید',
    'اپلیکیشن iOS',
    'اپلیکیشن ویندوز',
    'اپلیکیشن تحت وب',
    'API سمت کاربر',
    'شخصی سازی ابزارک گفتگو',
    'گفتگوی همزمان با کاربران',
    'امکان پاسخگویی از تلگرام',
    'تغییر وضعیت اپراتور ( آنلاین/آفلاین )',
    'خروجی اکسل از آمار اپراتورها',
    'خروجی اکسل از اطلاعات کاربران',
    'پایگاه دانش',
    'شخصی سازی لوگو ابزارک',
    'مانیتوریتگ لحظه‌ای بازدید کنندگان در اپلیکیشن‌ها',
    'ارسال ایمیل به کاربران',
    'مکالمه ما بین اپراتورها',
    'انتقال گفتگو مابین اپراتورها',
    'پاسخ‌های آماده با امکان شخصی سازی',
    'زمان‌های کاری',
    'نمایش اطلاعات کامل کاربران',
    'مشاهد لحظه‌ای متون تایپ شده توسط کاربر',
    'افزودن کاربر به اسپم',
    'آمار حرفه‌ای اپراتورها',
    'وبینار رایگان آموزشی + فایل های آماده',
    'امکان دانلود فاکتور رسمی',
  ],

  MODAL_FREE_TITLE: 'رایگان',
  MODAL_FREE_FEATURES_1: '0',
  MODAL_FREE_FEATURES_2: '100',
  MODAL_FREE_FEATURES_3: '0',
  MODAL_FREE_PRICE: 'رایگان',

  MODAL_PROFESSIONAL_TITLE: 'پایه',
  MODAL_PROFESSIONAL_PRICE: '۸۹',
  MODAL_PROFESSIONAL_ANNUAL_PRICE_AFTER_DISCOUNT: '۱،۰۶۸',

  MODAL_PROFESSIONAL_FEATURES: [
    'پایه',
    '۱۷۸',
    '',
    '۵۰۰',
    '۹۰۰ تومان / هرمکالمه',
    '۱ وبسایت',
    'نامحدود',
    '-',
    '-',
    '-',
    '۵۰۰',
    '۱۰ مگابایت',
    '۳۰ روز',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '1',
    '1',
    '1',
    '1',
    '0',
    '1',
    '1',
    '0',
    '1',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '1',
    '1',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '1',
    '1',
  ],

  MODAL_COMMERICAL_TITLE: 'تجاری',
  MODAL_COMMERICAL_PRICE: '۲۷۹',

  MODAL_COMMERCIAL_ANNUAL_PRICE_AFTER_DISCOUNT: "۹.۱۸۰",
  MODAL_COMMERICAL_FEATURES: [
    "رشد",
    "۸۵۰",
    "۱۰.۲۰۰",
    "۱۰۰۰",
    "۹۰۰ تومان / هرمکالمه",
    "۵ وبسایت",
    "۲۰",
    "-",
    "-",
    "تا ۶ پیام",
    "۱۰۰۰",
    "۲۰ مگابایت",
    "۱۸۰ روز",
    "0",
    "0",
    "0",
    "1",
    "0",
    "1",
    "1",
    "0",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "0",
    "1",
    "0",
    "0",
    "0",
    "0",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1"
  ],

  MODAL_PREMIUM_ANNUAL_PRICE_AFTER_DISCOUNT: "۱۷.۲۸۰",
  MODAL_PREMIUM_PLUS_ANNUAL_PRICE_AFTER_DISCOUNT: "۴۸.۶۰۰",
  MODAL_VIP_ANNUAL_PRICE_AFTER_DISCOUNT: "۱۸۰.۰۰۰",
  MODAL_PREMIUM_FEATURES: [
    "پریمیوم",
    "۱.۶۰۰",
    "۱۹.۲۰۰",
    "۵۰۰۰",
    "-",
    "۱۵ وبسایت",
    "۱۰۰",
    "۵ مرحله",
    "۵ اکانت",
    "تا ۱۵ پیام",
    "۵۰۰۰",
    "۳۰ مگابایت",
    "۳۶۵ روز",
    "0",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1"
  ],
  MODAL_PREMIUM_PlUS_FEATURES: [
    "پریمیوم پلاس",
    "۴.۵۰۰",
    "۵۴.۰۰۰",
    "۵۰۰۰۰",
    "-",
    "۳۰ وبسایت",
    "۵۰۰",
    "۱۵ مرحله",
    "۱۵ اکانت",
    "نا محدود",
    "نامحدود",
    "۱۰۰ مگابایت",
    "۵ سال",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1"
  ],
  MODAL_PREMIUM_TITLE: 'پریمیوم',
  MODAL_PREMIUM_PRICE: '۸۷۹',

  MODAL_VIP_FEATURES: [
    "VIP",
    "۱۵.۰۰۰",
    "۳۰،۰۰۰",
    "نامحدود",
    "-",
    "نامحدود",
    "نامحدود",
    "۳۰ مرحله",
    "۳۰ اکانت",
    "نا محدود",
    "نامحدود",
    "۱۰۰ مگابایت",
    "۵ سال",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1",
    "1"
  ],

  CUSTOMER_NAME: 'عادل طالبی',
  CUSTOMER_QUOTE:
    'از چت های آنلاین بسیاری استفاده کرده‌ام، از جمله زوپیم، کریسپ، جیووچت، لایوچت و... <br />سه نکته در رایچت برای‌ ما اهمیت حیاتی دارد : اول سادگی استفاده از آن، دوم پرداخت ریالی و سوم پشتیبانی.',
  CUSTOMER_ROLE: 'استراتژیست کسب و کار های آنلاین',

  FAQ_TITLE: 'سوالات متداول',
  FAQ_SUB_TITLE:
    'در صورتی که جواب خود را پیدا نکردید به بخش #مقالات# مراجعه کنید',

  FAQ_QUESTIONS: [
    {
      title:
        'بعد از خرید بسته، امکان نصب رایچت بر روی چند وبسایت مختلف وجود دارد؟',
      content:
        'شما میتوانید بر اساس امکانات پکیج های خریداری شده، متناسب با شرایط آن بسته بر روی همان تعداد سایت نصب کنید .',
    },
    {
      title: 'آیا هر پیام ارسال شده به کاربر، یک مکالمه محسوب می شود؟',
      content:
        'خیر، هر پیام ارسالی توسط کاربران یک مکالمه محسوب نمیشود بلکه آغاز مکالمه با کاربر مدنظر است و ممکن است در طول سال این کاربر چندین بار با شما مکالمه مداوم داشته باشد.',
    },
    {
      title: 'بعد از  پایان یافتن پکیج آزمایشی، چه اتفاقی می افتد؟',
      content:
        'پکیج منقضی به صورت خودکار فعال میشود و شما میتوانید نسبت به ارتقا پکیج از پنل مدیریت اقدام کنید .',
    },
    {
      title: 'استفاده از رایچت برای یک کاربر با گوشی موبایل ممکن می باشد؟',
      content:
        'بله، رایچت کاملا واکنشگرا طراحی شده و کاربران شما با تمامی مرورگرهای مدرن تلفنهای هوشمند میتوانند با شما گفتگو کنند.',
    },
    {
      title:
        'اگر مدت زمان مکالمه مان به پایان برسد، امکان شارژ مجدد آن وجود دارد؟',
      content:
        'بله، شارژ مکالمات  با قیمت هر مکالمه ۳۹۹ هزار تومان برای تمامی پکیج ها از قسمت داشبورد امکان پذیر است.',
    },
    {
      title:
        'آیا با ارتقاء پکیج پایه به تجاری ، قبل از اتمام زمان پکیج، مدت زمان الباقی نیز انتقال پیدا می کند؟',
      content:
        'خیر، با ارتقاء به پکیج تجاری مدت زمان تمدید شده در پکیج تجاری برای شما ثبت خواهد شد.',
    },
  ],

  TALK_TO_US_TITLE: 'به پاسخ سوالتون نرسیدید؟',
  TALK_TO_US_SUB_TITLE:
    'کافیه روی ابزارک گوشه وبسایتمون کلیک کنید و توی صفحه باز شده، سوالتون رو بپرسید. تیم پشتیبانی ما در اسرع وقت پاسخ سوالتون رو میدن.',
};

export default PACKAGES_COMPARE;
